import type { RequestSmartCardResponse } from 'rest/smart-card';
import { getRequestSmartCardData } from 'rest/smart-card';
import { CardClient } from '@atlaskit/link-provider';
import { parseIssueKeyFromUrl } from '@atlassian/help-center-common-util/url';

export class PortalCardClient extends CardClient {
    async fetchData(url: string) {
        const issueKey = parseIssueKeyFromUrl(url);
        if (issueKey === null) {
            // This doesn't look like Jira URL, so let's use native resolver
            return super.fetchData(url);
        }

        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return getRequestSmartCardData(issueKey).then((response) => this.createResolveResponse(issueKey, response));
    }

    prefetchData() {
        return Promise.resolve(undefined);
    }
    /* eslint-disable  @typescript-eslint/no-explicit-any */

    createResolveResponse = (issueKey: string, response: RequestSmartCardResponse): any => {
        return {
            meta: {
                visibility: 'restricted',
                access: 'granted',
                auth: [],
                definitionId: 'jira-native-resolve',
            },
            data: {
                '@context': {
                    '@vocab': 'https://www.w3.org/ns/activitystreams#',
                    atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
                    schema: 'http://schema.org/',
                },
                '@type': ['atlassian:Task', 'Object'],
                name: `${issueKey}: ${response.summary}`,
                tag: {
                    name: response.status,
                    appearance: 'default',
                },
                url: response.url,
                taskType: {
                    '@type': ['Object', 'atlassian:TaskType'],
                    '@id': 'https://www.atlassian.com/#JiraCustomTaskType',
                    name: response.requestType.name,
                },
                icon: {
                    '@type': 'Image',
                    url: response.requestType.iconUrl,
                },
                generator: {
                    '@type': 'Application',
                    '@id': 'https://www.atlassian.com/#Jira',
                    name: 'Jira',
                },
            },
        };
    };
}
